import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabaseClient';
import { config } from '../lib/config';
import { demoStore } from '../features/demo/store';

export const usePost = (id?: string) => useQuery({ queryKey:['post',id], enabled:Boolean(id), queryFn:async () => { if (!id) throw new Error('Post id missing'); if (config.e2e) { const post=demoStore.posts().find((item)=>item.id===id); if (!post) throw new Error('Post not found'); return post; } const { data,error } = await supabase.from('posts').select('*').eq('id',id).single(); if (error) throw error; return data; } });
